<template>
  <div class="modal fade in modal-auto" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content" v-async="loading">
        <div class="modal-header modal-info">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            v-on:click="hideModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">Alterar Valor da Recarga Automática</h4>
        </div>
        <div class="modal-body">
          <p class="bold-600 text-center no-margin">Valor da Recarga</p>

          <dropdown
            class="dropdown-recharge text-right recharge-value-dropdown"
            v-model="value"
            :options="rechargesData"
            v-on:itemSelected="changeRecharge"
            :value="value"
          >
          </dropdown>
          <div class="row margin-t20" v-if="value == -1">
            <div
              class="form-group col-xs-12"
              :class="{ 'has-error': errors.has('valueTotal') }"
            >
              <input
                class="form-control text-right input-recharge"
                id="valueTotal"
                type="text"
                name="valueTotal"
                placeholder="R$ 00,00"
                v-bind:value="valueFormatted"
                v-on:input="setTotal($event.target.value)"
                v-validate="'required|recargaMinima:' + minValue"
                spellcheck="false"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                autofocus
              />
              <div class="help-block help-block-recharge with-errors">
                {{ errors.first("valueTotal") }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="recharge-open-tax">
              Taxa de Recarga:
              <p>{{ tax | cents }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="hideModal()">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-success"
            data-dismiss="modal"
            @click="alterRechargeUnit()"
          >
            Confimar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import contract from "../../../services/contracts";
import Sales from "../../../services/sales";
import { EventBus } from "../../../event-bus";
import axios from "axios";
import { cents } from "../../../filters/number";
import validaRecarga from "../../../validators/recarga-minima";

export default {
  props: ["contract"],
  data() {
    return {
      rechargeAlter: {},
      recharge: undefined,
      loading: undefined,

      rechargeValue: 0,
      qtdFix: 4,
      rechargesData: [],
      value: undefined,
      tax: "-",
      source: undefined,
      minValue: 200000,
    };
  },
  mounted() {
    this.source = axios.CancelToken.source();

    this.rechargesData = this.getFixesRecharges(this.planId, this.minValue);
    this.rechargesData.push({
      value: -1,
      caption: `Outro valor (deve ser maior que ${cents(this.minValue)}`,
    });

    if (this.contract.rechargeValue) {
      this.value = this.rechargeValue = this.contract.rechargeValue;
      if (this.value > this.minValue) {
        this.value = -1;
        this.calculateRecharge();
      }
    }
  },
  computed: {
    valueFormatted: function () {
      this.$nextTick(() => {
        //para o cursor continuar no final do input
        $("#valueTotal").val($("#valueTotal").val());
      });
      return cents(this.rechargeValue).replace("R$", "");
    },

    planId() {
      return this.contract.plan.planId;
    },
  },
  methods: {
    hideModal() {
      this.rechargeAlter = this.recharge;
      this.$emit("closeModalRecharge", this.contract.contractId);
    },
    alterRechargeUnit() {
      if (
        this.value == -1 &&
        parseInt(this.rechargeValue) < parseInt(this.minValue)
      )
        return false;

      this.loading = contract
        .updateContractValueRecharge(
          this.contract.contractId,
          this.rechargeValue
        )
        .then((response) => {
          if (response.data.status.code == 0) {
            this.contract.rechargeValue = this.rechargeValue;
          }
          this.$emit(
            "closeModalRecharge",
            this.contract.contractId,
            this.rechargeValue
          );
        });
    },
    changeRecharge(item) {
      if (!item) return;
      this.tax = item.tax;
      this.rechargeValue = item.value;
      this.contract._quantity = item.quantity;
      if (item.value == -1) {
        this.rechargeValue = 0;
        this.tax = "-";
      }
    },
    calculateRecharge: function () {
      if (!validaRecarga.validate(this.rechargeValue, [this.minValue])) {
        this.tax = "-";
        return false;
      }
      this.source.cancel("cancelada");
      this.source = axios.CancelToken.source();
      this.waiting = true;
      let r = this.rechargeValue;
      this.loading = Sales.calculateRechargeRate({
        cancelToken: this.source.token,
        value: r,
        planId: this.planId,
      })
        .then((resp) => {
          this.rechargeValue = r;
          this.tax = resp.taxTotal;
          this.waiting = false;
        })
        .catch((err) => {
          this.waiting = false;
          this.tax = "-";
        });
    },
    setTotal: function (newValue) {
      this.rechargeValue = newValue.replace(/[^0-9]/g, "");
      this.calculateRecharge();
    },
  },
};
</script>
<style scoped lang="scss">
.modal-auto {
  background: rgba(230, 230, 230, 0.8);
  display: block;
}
.dropdown-recharge {
  width: 100%;
}
.dropdown-recharge > .btn-dropdown {
  text-align: right;
  padding-right: 30px;
}
.box-plus-minus {
  text-align: center;
  .form-control {
    font-size: 1.4em;
    width: 200px;
    text-align: center;
    height: 40px;
    margin: 0px -6px;
  }
  .btn-charge {
    border: 2px solid #b5b5b5;
    padding: 10px;
    color: black;
    margin-top: 5px;
    i {
      font-size: 1.2em;
    }
  }
}
.btn-success {
  margin-left: 10px;
  .align-icon-right-white {
    right: -19px;
  }
}
.info-box-left {
  padding-left: 20%;
}
.label-detail {
  margin-right: 20px;
  text-align: right;
  width: 190px;
}
.alt-value .btn-back {
  margin-left: 10px;
  padding: 5px 24px;
  .align-icon-right {
    right: -18px;
  }
  &:hover,
  &:active {
    padding: 5px 24px;
  }
}
.track-order {
  vertical-align: bottom;
}
small {
  display: block;
  padding: 0px 10px;
}
.content-box {
  margin: 5px;
  h3,
  p {
    margin: 0;
  }
  & .background-solid {
    background-color: #f2f2f2;
  }
}
.delivery-box {
  width: 220px;
  display: inline-block;
  vertical-align: top;
  height: 100px;
}
.icon-check {
  vertical-align: baseline;
  margin: 0px 10px;
}
.info-check {
  display: inline-block;
}
.help-block {
  font-size: 0.9em !important;
  line-height: 30px;
  position: absolute;
  right: 15px;
  text-align: right;
}
.content-box.methods {
  .col-md-6 div {
    display: inline-block;
    padding: 0px 10px;
  }
  small {
    padding: 0px;
  }
  h5,
  p {
    margin: 0;
  }
  .credit-card {
    vertical-align: baseline;
  }
}
.cell-plate > div {
  line-height: 30px;
  margin: 5px;
}
.label-link {
  float: right;
  font-size: 0.8em;
  font-weight: 400;
}
.button-title {
  margin-top: 0px;
}
.recharge-open-tax {
  display: block;
  padding: 20px 5px 0;
  text-align: center;
  width: 100%;
}
@media screen and (max-width: 991px) {
  .info-box,
  .info-box-left {
    padding-left: 10px;
  }
  .label-detail {
    width: 100%;
    text-align: left;
  }
  .recharge {
    width: 95%;
  }
}

@media (min-width: 320px) {
  .btn-sm {
    padding: 5px !important;
  }
  .border-right-gray {
    border-right: 0px;
  }
  .request-status {
    text-align: left;
  }
  .icon-coin.align-icon-right-white {
    display: none;
  }
  .box-payment {
    .btn-back {
      padding: 9px;
    }
  }
}

@media (min-width: 370px) {
  .btn-sm {
    padding: 5px 25px !important;
  }
  .icon-coin.align-icon-right-white {
    display: block;
  }
  .box-payment {
    .btn-back {
      padding: 9px 50px 10px 40px;
    }
  }
}

@media (min-width: 530px) {
  .border-right-gray {
    border-right: 2px solid #f2f2f2;
  }
  .box-payment {
    position: relative;
    height: 42px;
    p {
      position: absolute;
      bottom: 0;
    }
  }
  .h-rule-side-yellow.payment {
    margin-top: 2px;
  }
}

@media (min-width: 992px) {
  .request-status {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// modal-automatic-value.vue?1eedaf4c